<p-editor
  #input
  [(ngModel)]="model"
  (ngModelChange)="onChange()"
  [readonly]="!editable"
  [placeholder]="placeholder"
  [ngClass]="{ readonly: !editable }"
>
  <p-header class="header" *ngIf="enableAllFormattingTools">
    <span class="ql-formats"></span>
  </p-header>
</p-editor>
